export const RBA = 'RBA';
export const IRONPLANET = 'IronPlanet';
export const TRUCKPLANET = 'TruckPlanet';
export const GOVPLANET = 'GovPlanet';
export const SALVAGESALE = 'SalvageSale';
export const UNKNOWN_PLATFORM = 'Unknown';

export interface PlatformTypeOption {
  code: string;
  name: string;
}
export enum assetPlatform {
  RBA = 'RBA',
  IRONPLANET = 'IronPlanet',
  TRUCKPLANET = 'TruckPlanet',
  GOVPLANET = 'GovPlanet',
  SALVAGESALE = 'SalvageSale'
}

export const onlinePlatformOptions: PlatformTypeOption[] = [
  {
    code: IRONPLANET,
    name: assetPlatform.IRONPLANET
  },
  {
    code: TRUCKPLANET,
    name: assetPlatform.TRUCKPLANET
  },
  {
    code: GOVPLANET,
    name: assetPlatform.GOVPLANET
  },
  {
    code: SALVAGESALE,
    name: assetPlatform.SALVAGESALE
  }
];

export const livePlatformOptions: PlatformTypeOption[] = [
  {
    code: RBA,
    name: assetPlatform.RBA
  }
];


export const consigmentPlatformOptions: PlatformTypeOption[] = [
  {
    code: RBA,
    name: assetPlatform.RBA
  },
  {
    code: IRONPLANET,
    name: assetPlatform.IRONPLANET
  },
  {
    code: TRUCKPLANET,
    name: assetPlatform.TRUCKPLANET
  },
  {
    code: GOVPLANET,
    name: assetPlatform.GOVPLANET
  },
  {
    code: SALVAGESALE,
    name: assetPlatform.SALVAGESALE
  }
];

export const consignmentOnLinePlatformOptions: PlatformTypeOption[] = onlinePlatformOptions;
export const consignmentLivePlatformOptions: PlatformTypeOption[] = livePlatformOptions;

export const multiChannelPlatformOptions: PlatformTypeOption[] = [
  {
    code: RBA,
    name: assetPlatform.RBA
  },
  {
    code: IRONPLANET,
    name: assetPlatform.IRONPLANET
  },
  {
    code: TRUCKPLANET,
    name: assetPlatform.TRUCKPLANET
  },
  {
    code: GOVPLANET,
    name: assetPlatform.GOVPLANET
  },
  {
    code: SALVAGESALE,
    name: assetPlatform.SALVAGESALE
  }
];
